module.exports = __webpack_public_path__ + "img/img4.02c13b26.png";